// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1ZFXA","header":"PatientQuestionnaire_header__38HXU","info":"PatientQuestionnaire_info__2f95U"};